// Decorative particle backdrop for the home page.
//
// Three.js is pulled in with a dynamic import so the ~570 kB bundle is fetched
// *after* the page has painted. The lesson cards are static HTML and must never
// wait on this. If it fails to load, the page is simply left without particles.

const canvas = document.querySelector('canvas.backdrop')
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

const startBackdrop = async () => {
    const THREE = await import('three')

    const scene = new THREE.Scene()

    const sizes = {
        width: window.innerWidth,
        height: window.innerHeight
    }

    const particlesCount = 900
    const positions = new Float32Array(particlesCount * 3)

    for (let i = 0; i < particlesCount * 3; i++) {
        positions[i] = (Math.random() - 0.5) * 12
    }

    const particlesGeometry = new THREE.BufferGeometry()
    particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))

    const particlesMaterial = new THREE.PointsMaterial({
        size: 0.022,
        color: '#8b83ff',
        sizeAttenuation: true,
        transparent: true,
        opacity: 0.75,
        depthWrite: false
    })

    const particles = new THREE.Points(particlesGeometry, particlesMaterial)
    scene.add(particles)

    const camera = new THREE.PerspectiveCamera(60, sizes.width / sizes.height, 0.1, 100)
    camera.position.z = 5
    scene.add(camera)

    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true })
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    // Fade in once there is something to show, so it does not pop in
    canvas.classList.add('is-ready')

    window.addEventListener('resize', () => {
        sizes.width = window.innerWidth
        sizes.height = window.innerHeight

        camera.aspect = sizes.width / sizes.height
        camera.updateProjectionMatrix()

        renderer.setSize(sizes.width, sizes.height)
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    })

    // Let the particles lean towards the cursor
    const pointer = { x: 0, y: 0 }

    window.addEventListener('pointermove', (event) => {
        pointer.x = event.clientX / sizes.width - 0.5
        pointer.y = event.clientY / sizes.height - 0.5
    })

    const clock = new THREE.Clock()

    const tick = () => {
        const elapsedTime = clock.getElapsedTime()

        if (!prefersReducedMotion) {
            particles.rotation.y = elapsedTime * 0.03
            particles.rotation.x = -pointer.y * 0.15
            camera.position.x += (pointer.x * 0.6 - camera.position.x) * 0.03
            camera.lookAt(scene.position)
        }

        renderer.render(scene, camera)
        window.requestAnimationFrame(tick)
    }

    tick()
}

// Wait for the browser to go idle so the backdrop never competes with the
// first paint of the actual content.
const whenIdle = window.requestIdleCallback ?? ((fn) => setTimeout(fn, 200))
whenIdle(() => startBackdrop().catch(() => {}))
